<script lang="ts">
  import { cn } from "$lib/utils"

  interface Props {
    backgroundColor?: string | undefined
    className?: string | undefined
    containerClassName?: string | undefined
    animate?: boolean | undefined
    children?: import("svelte").Snippet
  }

  let {
    backgroundColor = undefined,
    className = undefined,
    containerClassName = undefined,
    animate = true,
    children,
  }: Props = $props()

  let showGradientBorder = $derived(backgroundColor === "#ffffff")

  const variants = {
    initial: {
      backgroundPosition: "0 50%",
    },
    animate: {
      backgroundPosition: ["0, 50%", "100% 50%", "0 50%"],
    },
  }
</script>

{#if showGradientBorder}
  <div class={cn("relative group md:p-[3px]", containerClassName)}>
    <div class="hidden md:block">
      <div
        class={cn(
          "absolute inset-0 z-[1] rounded-xl transition-opacity duration-500 group-hover:opacity-100 opacity-60 gradient-border",
          animate && "animate-gradient",
        )}
      ></div>
    </div>

    <div class={cn("relative z-10 rounded-lg bg-white", className)}>
      {@render children?.()}
    </div>
  </div>
{:else}
  <div
    id="widget"
    class={cn("relative sm:rounded-[21px]", containerClassName)}
    style={`border-radius: 8px; ${
      backgroundColor.includes("linear")
        ? `padding: 2px; background: ${backgroundColor};`
        : `border: 2px solid ${backgroundColor};`
    }`}
  >
    <div class={cn("relative", className)}>{@render children?.()}</div>
  </div>
{/if}

<style>
  .gradient-border {
    background: linear-gradient(
      90deg,
      #00ccb1 0%,
      #7b61ff 33%,
      #ffc414 66%,
      #1ca0fb 100%
    );
  }

  @media (max-width: 768px) {
    div#widget {
      border: none !important;
    }
  }
</style>
